export class BankingHouseAccountDto {
  merchantId: number;
  merchantName: string;
  orderId: number;
  orderTotal: number;
  orderNote: string;
  createdDate: Date;
  discountAmount: number;
  serviceChargeAmount: number;
  deliveryFee: number;
  processingFee: number;
  orderPaymentId: number;
  settledAmount: number;
  houseAccountId: number;
  houseAccountName: string;
  houseAccountApprovalId: number;
  approvalDescription: string;
  approvedEmployeeId: number;
  approvedEmployeeUserName: string;
  isStandAloneOrder: boolean;
}
